var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _g2, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _g3, _path61, _g4, _path62, _g5, _path63, _path64, _path65, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHuman(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 325,
    viewBox: "0 0 206 325",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.8376 310.838L78.4537 308.828C65.6186 303.702 36.6291 304.991 46.1665 324.015C47.6322 324.015 87.9911 324.929 90.3727 324.015C92.0755 323.359 89.5645 317.577 88.0881 310.247C86.0944 313.235 81.8268 310.838 81.8268 310.838H81.8376Z",
    fill: "#3AB54A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1304 300.079C88.0657 304.013 88.1304 309.666 88.1304 309.666C88.1304 309.666 79.5305 310.257 79.1534 310.257C78.7762 310.257 78.2266 300.079 78.2266 300.079H88.1196H88.1304Z",
    fill: "url(#paint0_linear_482_6173)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5964 306.98C47.0074 308.732 41.0586 313.826 46.1668 324.015C46.7918 324.015 54.4649 324.176 63.2587 324.305L64.9722 320.64C65.2847 313.557 61.9655 306.604 55.5964 306.98Z",
    fill: "#6AC959"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7708 321.262C81.2549 321.606 44.808 320.628 44.808 320.628C44.808 320.628 42.9975 323.541 46.1658 324.411H90.372C92.1179 324.358 91.7622 323.003 90.7708 321.252V321.262Z",
    fill: "#003F30"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2056 310.246C68.184 308.193 65.8024 306.302 65.0049 306.28",
    stroke: "white",
    strokeWidth: 1.17365,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.653 310.063C71.6315 308.279 69.6701 306.645 69.002 306.634",
    stroke: "white",
    strokeWidth: 1.17365,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M87.465 168.774C75.5459 184.713 60.9542 199.846 40.8017 193.494C37.073 188.195 32.6222 186.014 31.9001 182.768C17.8355 178.54 14.0351 178.046 4.16737 167.918C3.109 166.832 1.27769 166.988 0.717327 168.397C-3.26595 178.415 10.5655 183.426 12.1761 186.47C2.55056 196.08 17.6015 209.445 30.8158 207.96C38.2536 206.912 38.7787 205.339 41.0496 205.951C54.402 210.174 67.6573 209.325 77.5396 197.6C87.7236 185.53 87.4434 168.785 87.4434 168.785L87.465 168.774Z",
    fill: "url(#paint1_linear_482_6173)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_482_6173",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 167,
    width: 88,
    height: 42
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M87.465 168.774C75.5459 184.713 60.9542 199.846 40.8017 193.494C37.073 188.195 32.6222 186.014 31.9001 182.768C17.8355 178.54 14.0351 178.046 4.16737 167.918C3.109 166.832 1.27769 166.988 0.717327 168.397C-3.26595 178.415 10.5655 183.426 12.1761 186.47C2.55056 196.08 17.6015 209.445 30.8158 207.96C38.2536 206.912 38.7787 205.339 41.0496 205.951C54.402 210.174 67.6573 209.325 77.5396 197.6C87.7236 185.53 87.4434 168.785 87.4434 168.785L87.465 168.774Z",
    fill: "url(#paint2_linear_482_6173)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_482_6173)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M40.23 202.67C36.5278 205.928 18.4608 206.817 11.6487 200.745L9.2793 210.371C13.7713 212.444 23.0812 216.828 24.3844 217.775C26.0134 218.96 61.851 218.072 63.7762 218.516C65.3163 218.871 71.6249 209.186 74.5867 204.299C75.2778 203.016 76.1565 199.768 74.1425 197.043C70.8845 202.522 49.7077 207.853 40.23 202.67Z",
    fill: "#EFA495"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8484 177.11C4.82398 181.438 13.7611 186.706 15.1723 189.152C22.2907 187.302 34.5896 183.225 26.8378 181.72C19.086 180.215 12.0051 174.382 9.43366 171.654C6.58005 172.03 1.26793 173.648 2.8484 177.11Z",
    fill: "url(#paint3_linear_482_6173)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M112.993 300.67C112.928 304.604 112.993 310.257 112.993 310.257C112.993 310.257 104.393 310.848 104.016 310.848C103.638 310.848 103.089 300.67 103.089 300.67H112.982H112.993Z",
    fill: "url(#paint4_linear_482_6173)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M106.301 310.247L103.175 308.828C90.3402 303.701 61.3508 304.991 70.8882 324.014C72.3539 324.014 112.713 324.928 115.094 324.014C117.476 323.101 113.812 318.813 114.092 307.635C112.53 313.31 106.301 310.247 106.301 310.247Z",
    fill: "#3AB54A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M114.103 307.645C114.243 305.979 113.424 307.043 112.088 309.02C110.751 310.998 104.382 308.375 102.917 307.462C101.451 306.548 100.276 307.784 101.623 308.268C102.971 308.752 104.9 309.859 106.268 310.364C107.637 310.869 109.253 311.514 111.592 310.772C113.931 310.031 114.114 307.645 114.114 307.645H114.103Z",
    fill: "#FCE01A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M114.103 307.645C114.243 305.979 113.424 307.043 112.088 309.02C110.751 310.998 104.382 308.375 102.917 307.462C101.451 306.548 100.276 307.784 101.623 308.268C102.971 308.752 104.9 309.859 106.268 310.364C107.637 310.869 109.253 311.514 111.592 310.772C113.931 310.031 114.114 307.645 114.114 307.645H114.103Z",
    fill: "#06A402"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3288 306.98C71.7398 308.732 65.791 313.827 70.8992 324.016C71.5242 324.016 79.1973 324.177 87.9911 324.306L89.7046 320.641C90.0171 313.558 86.6979 306.604 80.3288 306.98Z",
    fill: "#6AC959"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M115.503 321.264C105.987 321.608 69.5404 320.63 69.5404 320.63C69.5404 320.63 67.7299 323.543 70.8982 324.413H115.104C116.85 324.359 116.495 323.005 115.503 321.253V321.264Z",
    fill: "#003F30"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M92.937 310.247C92.9155 308.194 90.5338 306.303 89.7363 306.281",
    stroke: "white",
    strokeWidth: 1.17365,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3855 310.065C96.3639 308.281 94.4025 306.647 93.7344 306.636",
    stroke: "white",
    strokeWidth: 1.17365,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2819 173.944C81.2819 173.944 68.2851 185.713 66.7764 187.637C66.7764 193.806 68.9856 202.017 71.9384 206.348C74.8913 210.68 86.6918 194.773 88.9118 190.786C91.1318 186.798 90.4205 169.989 81.2819 173.944Z",
    fill: "url(#paint5_linear_482_6173)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8684 165.873C61.7932 206.983 48.3115 246.212 87.431 253.563C126.551 260.915 118.63 211.078 116.69 198.008C114.75 184.939 119.535 161.788 121.712 154.706C106.538 147.354 92.5608 154.448 85.8684 165.873Z",
    fill: "url(#paint6_linear_482_6173)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1321 179.767C83.5646 179.554 82.7724 178.26 82.4473 177.639C84.4573 175.481 89.4883 171.112 93.532 170.899C89.4528 171.963 84.8416 180.033 84.1321 179.767Z",
    fill: "#3AB54A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4859 181.685C98.4859 180.124 93.4692 174.903 90.9609 172.488L96.2563 173.045L118.274 168.447L117.995 172.07C114.929 174.346 106.735 179.455 98.4859 181.685Z",
    fill: "#3AB54A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M116.69 198.007C115.839 192.246 116.292 184.54 117.251 177.113C117.229 177.06 117.219 177.017 117.219 177.017L111.162 185.798C114.643 204.821 110.893 227.724 110.893 227.724L118.318 227.467C119.417 215.816 117.51 203.574 116.69 197.996V198.007Z",
    fill: "#3AB54A"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M116.852 169.031C116.852 169.031 102.832 175.899 98.327 175.007C93.8223 174.115 91.4191 172.234 91.4191 172.234L84.8345 170.708L84.3711 167.419L115.925 164.678L116.841 169.042L116.852 169.031Z",
    fill: "#EFA495"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M113.684 243.956C115.882 240.151 117.197 235.605 117.919 230.833L62.7743 225.685C62.6126 232.886 64.2938 239.087 68.3782 243.891C69.5313 267.021 73.3247 299.694 73.3247 299.694C78.282 303.165 87.8194 301.521 90.3843 299.694C88.7678 285.99 88.5738 259.787 88.5522 253.758C90.3843 254.059 92.1085 254.231 93.7358 254.284C95.2554 275.705 98.0573 299.694 98.0573 299.694C103.015 303.165 112.552 301.521 115.117 299.694C113.608 286.872 113.64 254.811 113.694 243.967L113.684 243.956Z",
    fill: "url(#paint7_linear_482_6173)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M108.424 301.595C111.367 301.294 113.953 300.51 115.106 299.693C113.597 286.871 113.63 254.81 113.684 243.966C115.753 240.376 117.035 236.12 117.779 231.638L110.86 234.475C113.134 238.817 108.726 244.718 108.047 246.782C107.368 248.845 111.625 294.534 108.597 301.111C108.521 301.283 108.468 301.445 108.424 301.606V301.595Z",
    fill: "#003F30"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M120.408 159.649C113.942 169.279 94.8028 172.869 91.4189 172.235C94.1993 174.051 99.1028 179.221 99.1028 179.221C99.1028 179.221 114.309 174.588 118.425 169.419C122.542 164.249 120.419 159.649 120.419 159.649H120.408Z",
    fill: "url(#paint8_linear_482_6173)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4187 172.237C86.0519 170.108 85.6531 169.507 84.7371 167.83C82.1723 169.442 81.3963 174.934 83.2176 178.513C86.8817 174.87 91.4187 172.237 91.4187 172.237Z",
    fill: "url(#paint9_linear_482_6173)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9145 222.878C61.2441 222.34 59.8 227.155 62.5912 229.337C65.3824 231.519 105.31 236.506 117.391 233.744C119.288 232.884 119.719 228.176 118.318 227.488C91.3112 228.703 77.0105 226.435 62.9037 222.888L62.9145 222.878Z",
    fill: "url(#paint10_linear_482_6173)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M118.328 227.48C115.741 227.599 113.273 227.684 110.902 227.738C113.823 228.792 112.562 234.38 110.859 234.466C113.457 234.359 115.709 234.122 117.401 233.735C119.298 232.876 119.729 228.168 118.328 227.48Z",
    fill: "#025B2C"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M134.001 204.574C132.492 195.815 127.47 181.703 119.377 174.201C114.387 169.59 107.566 181.381 112.652 189.463C115.4 194.686 120.228 198.781 122.427 209.207C122.427 218.675 120.271 244.008 120.271 244.008C114.571 246.415 112.814 253.154 113.342 255.25C113.87 257.346 117.189 258.324 117.189 255.884C117.189 260.076 115.26 259.506 115.4 262.472C115.54 265.439 126.576 266.965 130.671 263.3C134.766 259.635 135.025 251.778 130.908 243.696C130.736 243.814 135.51 213.312 134.001 204.585V204.574Z",
    fill: "url(#paint11_linear_482_6173)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M130.667 263.301C134.762 259.636 135.021 251.78 130.904 243.697C130.732 243.816 135.506 213.313 133.997 204.586C133.587 202.233 132.919 199.492 132.014 196.59C129.212 196.665 126.572 196.783 126.572 196.783L121.711 204.705C127.488 205.747 131.152 204.705 131.152 204.705C134.514 211.594 129.352 243.773 128.221 244.708C134.525 251.296 128.178 264.322 120.957 265.3H120.936C124.352 265.719 128.49 265.236 130.667 263.29V263.301Z",
    fill: "#EFA495"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M119.97 205.801C123.451 203.372 131.889 199.525 135.564 200.255C131.533 186.896 123.408 174.805 118.3 173.171C113.191 171.537 109.56 178.545 111.381 186.659C113.191 194.774 119.981 205.801 119.981 205.801H119.97Z",
    fill: "url(#paint12_linear_482_6173)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M118.3 173.17C116.781 172.687 115.401 172.977 114.259 173.815C119.389 174.234 128.182 189.389 130.586 200.856C132.536 200.287 134.325 200.007 135.564 200.255C131.534 186.895 123.408 174.804 118.3 173.17Z",
    fill: "#3AB54A"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3001 186.75C6.83436 190.475 8.06826 205.673 18.4797 206.737C28.8912 207.802 28.2429 195.275 26.998 191.983C24.207 184.598 12.3001 186.75 12.3001 186.75Z",
    fill: "url(#paint13_linear_482_6173)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1974 190.778C13.0048 192.142 10.1816 190.636 11.9202 186.544L24.3831 184.522C29.6513 189.225 38.4191 198.576 31.3447 198.351C22.5016 198.068 26.2906 189.622 20.1974 190.778Z",
    fill: "#FFB8A6"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9093 191.678C36.8832 180.907 27.0019 178.539 19.8709 180.004C12.74 181.468 9.1465 191.408 14.5063 190.829C19.8661 190.25 22.2969 187.733 24.0245 192.099C25.7522 196.464 33.6854 203.574 38.9787 196.863C40.5597 194.461 39.8894 191.682 39.8894 191.682L39.9093 191.678Z",
    fill: "url(#paint14_linear_482_6173)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0077 188.367C99.1729 188.266 99.2594 188.276 99.3994 188.435L99.218 189.479C99.0564 189.541 98.9702 189.528 98.8263 189.411L99.0077 188.367Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M108.244 189.971C108.409 189.871 108.496 189.88 108.636 190.039L108.454 191.084C108.293 191.145 108.207 191.133 108.063 191.016L108.244 189.971Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.344 190.347L100.611 188.813C100.636 188.634 100.688 188.592 100.846 188.619L106.836 189.659C107.014 189.687 107.049 189.747 107.008 189.925L106.742 191.459C107.329 191.561 107.788 191.439 107.875 191.033L108.036 190.103C108.135 189.246 107.332 188.35 106.728 188.245L101.457 187.329C100.625 187.185 99.6215 188.12 99.5826 188.635L99.421 189.565C99.4154 189.984 99.7944 190.319 100.344 190.347ZM102.076 187.824C101.851 187.785 101.637 187.936 101.597 188.161C101.558 188.386 101.709 188.601 101.934 188.64L105.753 189.303C105.979 189.342 106.193 189.191 106.232 188.966C106.271 188.741 106.12 188.526 105.895 188.487L102.076 187.824Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M175.204 61.1975L169.418 66.4143L169.409 66.4136C169.409 66.4136 164.833 96.8482 164.989 99.5355C165.145 102.223 173.753 101.936 177.117 102.743C181.888 102.163 180.574 100.872 181.35 96.227L182.554 82.1947C182.554 82.1947 184.373 70.3944 182.967 64.5608C181.562 58.7272 175.204 61.1975 175.204 61.1975Z",
    fill: "url(#paint15_linear_482_6173)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2041 47.3193L40.1477 53.4564L40.1564 53.4571C40.1564 53.4571 39.5311 84.2305 38.9105 86.8513C38.29 89.472 29.6471 87.706 26.111 87.921C21.3938 86.5269 22.9433 85.4819 22.9604 80.7715L24.1639 66.7392C24.1639 66.7392 24.3612 54.7999 26.7857 49.2947C29.2101 43.7896 35.2041 47.3193 35.2041 47.3193Z",
    fill: "url(#paint16_linear_482_6173)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1036 155.547C34.3423 166.307 150.596 177.381 162.331 167.231C165.618 164.215 171.486 63.6337 171.531 59.9683C171.576 56.3029 167.683 42.4263 156.682 36.6046C145.681 30.7828 78.9364 20.978 63.3765 25.4549C47.8167 29.9317 39.5652 39.5616 37.2255 47.7387C34.8859 55.9158 25.1179 153.342 26.1143 155.548L26.1036 155.547Z",
    fill: "url(#paint17_linear_482_6173)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1618 43.298C48.2523 45.0612 46.893 53.8721 45.7725 58.317C44.4089 64.5125 43.5812 76.7109 43.5475 78.2426C43.5137 79.7743 98.2577 91.7416 159.616 91.1791C160.67 89.7657 161.275 80.8388 161.539 68.8724C161.539 68.8724 163.04 56.4544 153.927 52.4223C130.774 45.2073 124.673 44.2831 103.868 41.8859C83.0631 39.4887 62.0712 41.5348 55.1618 43.298Z",
    fill: "url(#paint18_linear_482_6173)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M125.476 98.4386C115.859 97.6411 105.563 96.789 83.5666 94.9753C61.5589 93.1613 51.8618 106.983 48.1825 124.309C44.7062 140.725 46.0781 153.674 59.328 163.838C68.0825 167.115 77.9972 170.397 93.2859 171.634C109.912 172.98 115.22 171.59 126.261 171.107C141.578 168.906 147.739 151.995 147.925 132.493C148.118 111.711 135.081 99.2361 125.476 98.4386Z",
    fill: "url(#paint19_linear_482_6173)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M60.591 118.798C68.9341 115.894 76.1416 123.477 76.1416 123.477C76.1416 123.477 70.4373 122.937 66.0435 127.368",
    stroke: "#3A3A3A",
    strokeWidth: 2.3473,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M81.257 144.422L107.691 146.401C107.691 146.401 106.865 164.704 92.5016 163.514C78.127 162.324 81.2681 144.423 81.2681 144.423L81.257 144.422Z",
    fill: "#47180D"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1394 155.785C83.5337 159.599 86.4736 163.014 92.4908 163.514C98.4525 164.002 102.087 161.14 104.292 157.623C99.4622 152.211 86.7481 151.914 82.1504 155.796L82.1394 155.785Z",
    fill: "url(#paint20_linear_482_6173)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M117.734 106.039L129.329 102.727C130.058 102.515 130.822 102.893 131.113 103.587L131.975 105.692C132.352 106.61 131.734 107.635 130.74 107.732L118.282 108.94C117.545 109.007 116.872 108.53 116.692 107.815C116.503 107.045 116.961 106.261 117.734 106.039Z",
    fill: "#3A3A3A"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6172 102.912L69.2399 98.9402C68.5297 98.685 67.7326 99.0182 67.4102 99.7033L66.4317 101.759C66.0058 102.654 66.5593 103.708 67.5388 103.867L79.9055 105.795C80.6402 105.906 81.3383 105.471 81.5606 104.762C81.795 103.998 81.3827 103.202 80.628 102.935L80.6172 102.912Z",
    fill: "#3A3A3A"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M109.928 128.513C109.67 124.827 114.069 119.306 121.247 119.01C128.425 118.715 131.771 124.839 132.125 128.839C132.479 132.839 131.332 135.759 129.404 137.867C127.314 135.144 109.928 128.513 109.928 128.513Z",
    fill: "#46180D"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M111.032 139.91C108.26 134.173 108.356 123.871 116.909 121.093C125.462 118.314 129.923 124.544 130.562 128.859C131.202 133.174 130.491 137.526 127.295 140.906C125.254 140.876 111.043 139.911 111.043 139.911L111.032 139.91Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_482_6173",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 109,
    y: 120,
    width: 22,
    height: 21
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M111.032 139.91C108.26 134.172 108.356 123.87 116.909 121.092C125.462 118.313 129.923 124.543 130.562 128.858C131.202 133.174 130.491 137.525 127.295 140.905C125.254 140.875 111.043 139.91 111.043 139.91L111.032 139.91Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_482_6173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.795 141.933C122.317 142 126.039 138.238 126.108 133.532C126.177 128.826 122.567 124.957 118.046 124.891C113.524 124.825 109.802 128.586 109.733 133.292C109.664 137.998 113.274 141.867 117.795 141.933Z",
    fill: "#140401"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.054 133.867C111.504 131.314 112.56 130.807 112.93 132.959C113.3 135.112 114.546 138.391 117.835 138.561C121.123 138.732 122.694 135.139 123.352 134.392C124.01 133.645 124.396 134.697 124.322 135.919C124.248 137.142 122.481 140.465 119.853 141.684C117.224 142.903 113.186 141.342 111.477 136.944C111.043 134.556 111.054 133.855 111.054 133.855L111.054 133.867Z",
    fill: "#513C39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.846 133.59C122.263 133.611 123.428 132.482 123.449 131.069C123.47 129.656 122.338 128.493 120.921 128.473C119.504 128.452 118.339 129.581 118.318 130.994C118.297 132.407 119.429 133.569 120.846 133.59Z",
    fill: "white"
  }))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M110.15 140.022C111.688 138.609 126.88 140.323 128.154 140.931C129.428 141.54 128.655 142.507 126.098 141.947C123.54 141.387 111.592 140.566 110.664 140.675C109.737 140.783 109.494 140.624 110.15 140.022Z",
    fill: "#46180D"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M119.647 149.817C130.533 149.977 139.487 141.305 139.646 130.449C139.806 119.592 131.11 110.661 120.224 110.501C109.338 110.342 100.384 119.013 100.224 129.87C100.065 140.727 108.761 149.658 119.647 149.817Z",
    stroke: "url(#paint21_linear_482_6173)",
    strokeWidth: 2.3473,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M69.508 145.331C80.3568 145.49 89.2802 136.848 89.439 126.028C89.5977 115.209 80.9318 106.309 70.083 106.15C59.2341 105.99 50.3107 114.632 50.152 125.452C49.9932 136.272 58.6592 145.172 69.508 145.331Z",
    stroke: "url(#paint22_linear_482_6173)",
    strokeWidth: 2.3473,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1457 126.18C93.8925 124.303 96.7943 124.991 100.849 126.909",
    stroke: "url(#paint23_linear_482_6173)",
    strokeWidth: 2.3473,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M139.256 132.624C139.256 132.624 170.267 125.947 171.592 125.633C172.917 125.319 173.196 121.517 172.203 121.058C171.211 120.598 139.395 130.39 139.395 130.39L139.265 132.624L139.256 132.624Z",
    fill: "url(#paint24_linear_482_6173)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5651 121.178C51.5651 121.178 28.7259 107.847 27.0541 106.688C25.3823 105.528 24.5959 109.8 26.7602 110.989C28.9246 112.178 51.4494 124.058 51.4494 124.058L51.5653 121.167L51.5651 121.178Z",
    fill: "url(#paint25_linear_482_6173)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5542 126.227C89.46 125.719 89.7161 133.062 93.8092 133.026",
    stroke: "#3A3A3A",
    strokeWidth: 1.17365,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_482_6173",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 24,
    width: 146,
    height: 148
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1036 155.547C34.3423 166.307 150.596 177.381 162.331 167.231C165.618 164.215 171.486 63.6336 171.531 59.9682C171.576 56.3028 167.683 42.4262 156.682 36.6044C145.681 30.7827 78.9364 20.9779 63.3765 25.4547C47.8167 29.9316 39.5652 39.5615 37.2255 47.7386C34.8859 55.9157 25.1179 153.342 26.1143 155.548L26.1036 155.547Z",
    fill: "url(#paint26_linear_482_6173)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_482_6173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.4 43.6463C136.142 28.3889 118.655 23.4596 116.777 15.4788C127.536 17.2392 177.924 25.9242 190.13 32.4967C205.388 40.7122 194.825 60.6642 192.478 75.9216C190.13 91.1791 184.849 145.167 181.915 158.664C178.981 172.161 154.921 177.442 149.052 178.029C143.184 178.616 109.735 179.789 130.274 170.987C146.705 163.945 147.292 159.837 154.921 145.167C159.029 130.496 160.202 108.784 160.202 105.263C162.55 85.3108 162.99 66.5325 161.963 62.4247C159.616 53.0355 158.442 50.6882 151.4 43.6463Z",
    fill: "#003F30",
    fillOpacity: 0.15
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_482_6173",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 40,
    width: 119,
    height: 52
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1618 43.298C48.2523 45.0612 46.893 53.8721 45.7725 58.317C44.4089 64.5125 43.5812 76.7109 43.5475 78.2426C43.5137 79.7743 98.2577 91.7416 159.616 91.1791C160.67 89.7657 161.275 80.8388 161.539 68.8724C161.539 68.8724 163.04 56.4544 153.927 52.4223C130.774 45.2073 124.673 44.2831 103.868 41.8859C83.0631 39.4887 62.0712 41.5348 55.1618 43.298Z",
    fill: "url(#paint27_linear_482_6173)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_482_6173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.3525 84.7241L66.8975 41.886L75.113 40.1255L83.3285 86.4846L73.3525 84.7241Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.856 94.0058L125.139 43.5542L133.202 40.9357L144.946 95.4551L134.856 94.0058Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6795 87.5817L77.207 39.6849L79.9753 37.3888L88.508 89.1747L84.6795 87.5817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.351 96.2594L135.263 40.3639L137.851 37.4833L150.292 97.8884L146.351 96.2594Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_482_6173",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 40,
    width: 119,
    height: 52
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1618 43.298C48.2523 45.0612 46.893 53.8721 45.7725 58.317C44.4089 64.5125 43.5812 76.7109 43.5475 78.2426C43.5137 79.7743 98.2577 91.7416 159.616 91.1791C160.67 89.7657 161.275 80.8388 161.539 68.8724C161.539 68.8724 163.04 56.4544 153.927 52.4223C130.774 45.2073 124.673 44.2831 103.868 41.8859C83.0631 39.4887 62.0712 41.5348 55.1618 43.298Z",
    fill: "url(#paint28_linear_482_6173)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_482_6173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.616 91.1791L43.4248 78.2689L43.4248 80.6162L101.815 91.1791L157.257 93.5263L159.616 91.1791Z",
    fill: "#3A3A3A"
  }))), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M104.454 76.5084C95.065 78.0733 75.6999 81.4378 73.3525 82.3767L78.634 82.3767L104.454 76.5084Z",
    stroke: "#3A3A3A",
    strokeWidth: 1.17365
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M112.083 65.3588L122.059 87.6581L124.993 87.6581L112.083 65.3588Z",
    fill: "#3A3A3A"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.2795 191.057C99.294 190.974 99.373 190.918 99.4561 190.933L107.348 192.304C107.431 192.318 107.487 192.397 107.472 192.48L106.821 196.227C106.807 196.31 106.728 196.365 106.645 196.351L105.75 196.196L105.748 196.212C105.677 196.618 105.291 196.889 104.886 196.819C104.48 196.749 104.208 196.363 104.279 195.957L104.282 195.94L101.115 195.39L101.112 195.407C101.042 195.813 100.656 196.084 100.25 196.014C99.8445 195.943 99.5728 195.557 99.6432 195.152L99.6463 195.135L98.7531 194.98C98.67 194.966 98.6143 194.887 98.6288 194.804L99.2795 191.057ZM101.502 193.188C101.441 193.541 101.105 193.778 100.751 193.717C100.398 193.655 100.162 193.319 100.223 192.966C100.284 192.613 100.62 192.376 100.974 192.438C101.327 192.499 101.563 192.835 101.502 193.188ZM105.34 194.514C105.693 194.575 106.029 194.338 106.09 193.985C106.152 193.632 105.915 193.296 105.562 193.235C105.209 193.173 104.873 193.41 104.812 193.763C104.75 194.116 104.987 194.452 105.34 194.514Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_482_6173",
    x1: 79.6167,
    y1: 301.068,
    x2: 87.1504,
    y2: 305.385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD4CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9B3A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_482_6173",
    x1: 31.7795,
    y1: 184.51,
    x2: 39.5568,
    y2: 213.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FFE7E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924873,
    stopColor: "#FFB8A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_482_6173",
    x1: 31.7795,
    y1: 184.51,
    x2: 39.5568,
    y2: 213.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FFE7E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924873,
    stopColor: "#FFB8A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_482_6173",
    x1: 6.70574,
    y1: 180.685,
    x2: 17.7892,
    y2: 190.666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FFE7E1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.70743,
    stopColor: "#FFB8A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_482_6173",
    x1: 104.479,
    y1: 301.659,
    x2: 112.013,
    y2: 305.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD4CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9B3A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_482_6173",
    x1: 73.501,
    y1: 179.673,
    x2: 79.7454,
    y2: 182.467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72CD63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55BD3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_482_6173",
    x1: 74.305,
    y1: 199.019,
    x2: 111.502,
    y2: 205.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40AD46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855587,
    stopColor: "#03A200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_482_6173",
    x1: 71.3291,
    y1: 257.908,
    x2: 103.31,
    y2: 265.634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#116B66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08573F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_482_6173",
    x1: 97.206,
    y1: 174.03,
    x2: 115.639,
    y2: 167.987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65E372"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BC1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_482_6173",
    x1: 84.0043,
    y1: 172.687,
    x2: 89.8701,
    y2: 166.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65E372"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07BF24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_482_6173",
    x1: 61.3734,
    y1: 225.351,
    x2: 111.482,
    y2: 231.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12AA5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06723C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_482_6173",
    x1: 117.955,
    y1: 204.123,
    x2: 136.274,
    y2: 202.232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FFE7E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924873,
    stopColor: "#FFB8A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_482_6173",
    x1: 107.717,
    y1: 175.911,
    x2: 120.39,
    y2: 166.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72CD63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DA802"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_482_6173",
    x1: 18.6263,
    y1: 193.295,
    x2: 25.0629,
    y2: 201.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FFE7E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924873,
    stopColor: "#FFB8A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_482_6173",
    x1: 11.1255,
    y1: 182.976,
    x2: 26.7623,
    y2: 207.013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE7E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924873,
    stopColor: "#FFD3C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_482_6173",
    x1: 184.797,
    y1: 58.2389,
    x2: 151.857,
    y2: 93.6654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#198D46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FAD46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_482_6173",
    x1: 42.2507,
    y1: 48.3409,
    x2: 33.6331,
    y2: 92.7897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#198D46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69CE6F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_482_6173",
    x1: 188.002,
    y1: 50.0233,
    x2: 9.48574,
    y2: 170.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#098046"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49B546"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_482_6173",
    x1: 146.071,
    y1: 46.9812,
    x2: 49.313,
    y2: 96.4479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56C2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFE8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_482_6173",
    x1: 60.3601,
    y1: 110.234,
    x2: 146.301,
    y2: 163.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FFE7E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924873,
    stopColor: "#FFB8A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_482_6173",
    x1: 93.267,
    y1: 153.2,
    x2: 93.1149,
    y2: 163.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD4746"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA1312"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_482_6173",
    x1: 107.52,
    y1: 114.786,
    x2: 129.106,
    y2: 148.218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E9B57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#077540"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_482_6173",
    x1: 57.4229,
    y1: 110.42,
    x2: 78.9349,
    y2: 143.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E9B57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#077540"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_482_6173",
    x1: 101.198,
    y1: 127.725,
    x2: 91.1087,
    y2: 125.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E9B57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#098046"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_482_6173",
    x1: 167.603,
    y1: 125.48,
    x2: 142.315,
    y2: 128.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#098046"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_482_6173",
    x1: 24.6851,
    y1: 107.592,
    x2: 55.7555,
    y2: 121.539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EC374"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E9B57"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_482_6173",
    x1: 188.002,
    y1: 50.0232,
    x2: 9.48574,
    y2: 170.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#098046"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49B546"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_482_6173",
    x1: 146.071,
    y1: 46.9812,
    x2: 49.313,
    y2: 96.4479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56C2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFE8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_482_6173",
    x1: 146.071,
    y1: 46.9812,
    x2: 49.313,
    y2: 96.4479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56C2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFE8FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuman);
export default __webpack_public_path__ + "static/media/human.e93cec0165847bc81b934e0b4ead5a1d.svg";
export { ForwardRef as ReactComponent };